export class ForbiddenResponseError extends Error {
  constructor(message?: string) {
    super(message ?? "The user does not have access to the resource")
    this.name = "ForbiddenResponseError"
  }
}
